import {
  TextLight,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, View } from 'react-native';

type Props = {
  headerText: string;
  subHeaderText?: string;
};

export function ModalStepHeader({ headerText, subHeaderText }: Props) {
  const styles = useDynamicStyles(createStyles);

  return (
    <View style={styles.headerContainer}>
      <TextLight style={styles.headerText}>{headerText}</TextLight>
      {subHeaderText && (
        <TextLight style={styles.subHeaderText}>{subHeaderText}</TextLight>
      )}
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    headerContainer: {
      alignItems: 'center',
      gap: 8,
      marginBottom: 12,
    },
    headerText: {
      fontSize: isMobile ? 24 : 32,
      textAlign: 'center',
    },
    subHeaderText: {
      fontSize: isMobile ? 16 : 20,
      textAlign: 'center',
    },
  });
